import React, { useMemo } from 'react';
import styles from './Advt.module.css';

import { useGetParams } from '../../hooks/useGetParams';
// import { iconsSources } from '../../helpers/icons';
import { formatPhoneNumber } from '../../helpers/titreHelper';

export const Advt = React.memo(() => {
  const {
    phoneNumber,
    title,
    socials,
    qrTitle1,
    qrCode1,
    qrTitle2,
    qrCode2,
    phoneNumberFontSize,
    titleFontSize,
    sizeQR,
    paddingQR,
  } = useGetParams();

  let phoneNumberFormat = formatPhoneNumber(phoneNumber, '-');
  const socialsList = useMemo(() => socials?.split(','), [socials]);

  return (
    <div className={styles.advtBlock}>
      {/* {title && (
        <div className={styles.titleAndPhoneBlock}>
          <div
            className={styles.title}
            style={{
              fontSize: `${titleFontSize}rem`,
              lineHeight: `${titleFontSize}rem`,
            }}>
            {title}
          </div>

          <div
            className={styles.numberWrapper}
            style={{ flexWrap: socialsList?.length > 2 ? 'wrap' : 'nowrap' }}>
            {phoneNumber && (
              <div
                className={styles.phoneNumber}
                style={{
                  fontSize: `${phoneNumberFontSize}rem`,
                  lineHeight: `${phoneNumberFontSize}rem`,
                }}>
                {phoneNumberFormat}
              </div>
            )}
          </div>
        </div>
      )} */}

      <div className={styles.qrsWrapper}>
        {qrCode1 && (
          <div className={styles.qrItem}>
            {/* {qrTitle1 && (
              <div className={styles.qrTitle}>
                <img
                  src={iconsSources[qrTitle1.toLowerCase()]}
                  alt={qrTitle1}
                />
              </div>
            )} */}
            <div
              className={styles.qr}
              style={{
                height: `${sizeQR}rem`,
                width: `${sizeQR}rem`,
                padding: `${paddingQR}rem`,
              }}>
              <img
                src={qrCode1}
                alt="QR"
                style={{ borderRadius: paddingQR === '0' ? '1.04rem' : '0' }}
              />
            </div>
          </div>
        )}
        {qrCode2 && (
          <div className={styles.qrItem}>
            {/* {qrTitle2 && (
              <div className={styles.qrTitle}>
                <img
                  src={iconsSources[qrTitle2.toLowerCase()]}
                  alt={qrTitle1}
                />
              </div>
            )} */}
            <div
              className={styles.qr}
              style={{
                height: `${sizeQR}rem`,
                width: `${sizeQR}rem`,
                padding: `${paddingQR}rem`,
              }}>
              <img
                src={qrCode2}
                alt="QR"
                style={{ borderRadius: paddingQR === '0' ? '2rem' : '0' }}
              />
            </div>
          </div>
        )}
      </div>
    </div>
  );
});
